module.exports = __webpack_public_path__ + "media/images/goods_btn_ov-2bd0bafd2367296bdef4989e379a0b7d.gif";